module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-1-2f7c650f4b4a499b0837ec353e0289c4.jpg";